module.exports = require("bunyan");


//////////////////
// WEBPACK FOOTER
// external "bunyan"
// module id = 133
// module chunks = 0